export const DISPLAY_STAGES = Object.freeze({
  WELCOME: "welcome",
  PARLOR: "parlor",
  ACTIVE_QUESTION: "active-question",
  SHOW_ANSWER: "show-answer",
  FUN_FACT: "fun-fact",
  SHOW_QUESTION_RESULTS: "show-question-results",
  SHOW_QUESTION_GLOBAL_TOP_100: "show-question-global-top100",
  SHOW_ROUND_PARLOR_STANDINGS: "show-round-parlor-standings",
  SHOW_ROUND_GLOBAL_TOP_100: "show-round-global-top100",
  NEXT_QUESTION_INTRO: "next-question-intro",
  AD_BREAK: "ad-break",
  ROUND_INTRO: "round-intro",
  GAME_OVER: "game-over",
  IDLE: "idle",
});

export const RUNNING_GAME_DISPLAY_STAGES = Object.freeze([
  DISPLAY_STAGES.ACTIVE_QUESTION,
  DISPLAY_STAGES.SHOW_ANSWER,
  DISPLAY_STAGES.FUN_FACT,
  DISPLAY_STAGES.SHOW_QUESTION_RESULTS,
  DISPLAY_STAGES.SHOW_QUESTION_GLOBAL_TOP_100,
  DISPLAY_STAGES.SHOW_ROUND_PARLOR_STANDINGS,
  DISPLAY_STAGES.SHOW_ROUND_GLOBAL_TOP_100,
  DISPLAY_STAGES.NEXT_QUESTION_INTRO,
  DISPLAY_STAGES.AD_BREAK,
  DISPLAY_STAGES.ROUND_INTRO,
  DISPLAY_STAGES.GAME_OVER,
]);

export const NON_GAME_DISPLAY_STAGES = Object.freeze([
  DISPLAY_STAGES.WELCOME,
  DISPLAY_STAGES.PARLOR,
  DISPLAY_STAGES.IDLE,
]);
